(() => {
  try {
    return process.env.NODE_ENV === "development";
  } catch {
    return !1;
  }
})();
function c(n, r) {
  let e = n;
  return r.forEach((o) => {
    if (o in e) {
      const t = e[o];
      if (!t || typeof t != "object")
        throw new Error(
          `Existing object path is invalid. Part ${o} is not an object.`
        );
      e = t;
    } else {
      const t = {};
      e[o] = t, e = t;
    }
  }), e;
}
function i() {
  return c(window, [
    "__jam__",
    "exports"
  ]);
}
function a(n) {
  const r = i();
  r.metadata = n;
}
const s = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  metadata: a
}, Symbol.toStringTag, { value: "Module" }));
export {
  s as jam
};
